import { MEDIOS_DE_PAGO, type MedioPago } from '../../types/comprobante';
import type { ComprobanteFormulario } from '../../hooks/useComprobanteFormulario';
import { RadioGroup } from '../ui/RadioGroup';
import { TextInput } from '../ui/TextInput';
import { enLaEntidad } from '../../utils/comprobanteEntidad';

const OPCIONES_BOLETA = [
  { value: 'si', label: 'Sí' },
  { value: 'no', label: 'No' },
] as const;

interface MedioPagoFolioProps {
  readonly comprobante: ComprobanteFormulario;
  readonly deshabilitado?: boolean;
}

export const MedioPagoFolio: React.FC<MedioPagoFolioProps> = ({ comprobante, deshabilitado = false }) => {
  if (!comprobante.pideMedioPago) return null;
  const esEfectivo = comprobante.medioPago === 'efectivo';
  // Solo cuando la entidad paga se pregunta por la boleta; al recibir, el comprobante es siempre su recibo.
  const preguntaPorBoleta = esEfectivo && comprobante.sentidoDinero === 'egreso';
  return (
    <div className="space-y-3">
      <RadioGroup
        label="Medio de pago"
        name="medio-pago"
        orientation="horizontal"
        options={MEDIOS_DE_PAGO}
        value={comprobante.medioPago}
        onChange={(valor) => { comprobante.cambiarMedioPago(valor as MedioPago); }}
        disabled={deshabilitado}
      />
      {preguntaPorBoleta && (
        <RadioGroup
          label="¿Te entregaron boleta o factura?"
          name="boleta-factura"
          orientation="horizontal"
          options={OPCIONES_BOLETA}
          value={comprobante.esReciboTalonario ? 'no' : 'si'}
          onChange={(valor) => { comprobante.cambiarEsReciboTalonario(valor === 'no'); }}
          disabled={deshabilitado}
        />
      )}
      {esEfectivo && comprobante.esReciboTalonario && (
        <div>
          <TextInput
            label="Folio del recibo de talonario"
            required={comprobante.folioObligatorio}
            labelHelp={comprobante.folioObligatorio
              ? undefined
              : <span className="text-sm text-slate-400 font-normal">(opcional)</span>}
            type="number"
            min={1}
            value={comprobante.folio}
            onChange={comprobante.cambiarFolio}
            onBlur={comprobante.verificarFolio}
            placeholder="Ej: 342"
            disabled={deshabilitado}
          />
          {comprobante.folioRepetido && comprobante.entidad && (
            <p role="status" className="mt-1 text-sm text-amber-700">
              Ya existe un movimiento con el folio {comprobante.folio} {enLaEntidad(comprobante.entidad)}. Revisa que no sea el mismo recibo.
            </p>
          )}
        </div>
      )}
    </div>
  );
};
